/*
 * Vinterns bränsle: lägger automatiskt till gratiskartongen i varukorgen.
 *   48 L (Large)       -> 12 L (Small) på köpet
 *   96 L (Extra Large) -> 24 L (Medium) på köpet
 * Själva rabatten (100 %) görs av de automatiska "köp X få Y"-rabatterna i Shopify.
 * Gratisraderna märks med den dolda egenskapen _vauni_gratis så att egna köp av
 * 12 L / 24 L aldrig räknas som gratis.
 * Till och med söndag 25/10 gäller det alla i butiken (automatiska rabatter).
 * Från måndag 26/10 gäller det bara den som kommit via mejlets länkar, alltså när
 * rabattkoden BRANSLE48 / BRANSLE96 finns i varukorgen (t.o.m. 15/11).
 * Säkerhet: efter slutdatumet gör skriptet ingenting, och om kassan inte drar av
 * hela priset på en gratisrad tas raden bort direkt.
 */
(function () {
  var END = new Date('2026-11-15T23:59:59+01:00');
  if (new Date() > END) return;

  var AUTO_END = new Date('2026-10-26T00:00:00+01:00');
  var RULES = [
    { buy: 50834320228693, get: 50834320163157, code: 'BRANSLE48' },
    { buy: 50834320261461, get: 50834320195925, code: 'BRANSLE96' }
  ];
  var PROP = '_vauni_gratis';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var off = false;
  try { off = sessionStorage.getItem('vauniGratisAv') === '1'; } catch (e) {}

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function isFree(item) {
    return item.properties && item.properties[PROP];
  }

  function ruleActive(rule, cart) {
    if (new Date() < AUTO_END) return true;
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code).toUpperCase() === rule.code;
    });
  }

  function changesFor(cart) {
    var adds = [];
    var updates = {};
    RULES.forEach(function (rule) {
      var bought = 0;
      var freeLines = [];
      cart.items.forEach(function (item) {
        if (item.variant_id === rule.buy) bought += item.quantity;
        if (item.variant_id === rule.get && isFree(item)) freeLines.push(item);
      });
      if (!ruleActive(rule, cart)) bought = 0;
      var free = freeLines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (free < bought) {
        var props = {};
        props[PROP] = '1';
        adds.push({ id: rule.get, quantity: bought - free, properties: props });
      } else if (free > bought) {
        var keep = bought;
        freeLines.forEach(function (item) {
          var qty = Math.min(item.quantity, keep);
          keep -= qty;
          if (qty !== item.quantity) updates[item.key] = qty;
        });
      }
    });
    return { adds: adds, updates: updates };
  }

  // Kontrollerar att kassan verkligen gör gratiskartongerna gratis. Om inte (t.ex. om
  // rabatten har avslutats i Shopify) tas gratisraderna bort och skriptet stängs av.
  function undiscountedFreeLines(cart) {
    var updates = {};
    RULES.forEach(function (rule) {
      if (!ruleActive(rule, cart)) return;
      var freeQty = 0, unit = 0, discounted = 0, freeKeys = [];
      cart.items.forEach(function (item) {
        if (item.variant_id !== rule.get) return;
        discounted += item.original_line_price - item.final_line_price;
        if (isFree(item)) {
          freeQty += item.quantity;
          unit = item.original_price;
          freeKeys.push(item.key);
        }
      });
      if (freeQty && discounted + 1 < freeQty * unit) {
        freeKeys.forEach(function (key) { updates[key] = 0; });
      }
    });
    return updates;
  }

  function refreshUi() {
    if (window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function turnOff(updates) {
    off = true;
    try { sessionStorage.setItem('vauniGratisAv', '1'); } catch (e) {}
    return post('cart/update.js', { updates: updates });
  }

  function sync(cart) {
    if (off || busy || !cart || !cart.items) return;
    var todo = changesFor(cart);
    var hasUpdates = Object.keys(todo.updates).length > 0;
    if (!todo.adds.length && !hasUpdates) {
      var bad = undiscountedFreeLines(cart);
      if (Object.keys(bad).length) {
        busy = true;
        turnOff(bad).then(refreshUi).finally(function () { busy = false; });
      }
      return;
    }
    busy = true;
    var step = hasUpdates ? post('cart/update.js', { updates: todo.updates }) : Promise.resolve();
    step
      .then(function () { return todo.adds.length ? post('cart/add.js', { items: todo.adds }) : null; })
      .then(getCart)
      .then(function (fresh) {
        var bad = undiscountedFreeLines(fresh);
        return Object.keys(bad).length ? turnOff(bad) : null;
      })
      .then(refreshUi)
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && cart.items) sync(cart); else getCart().then(sync);
  });

  getCart().then(sync).catch(function () {});
})();
